<template>
  <div class="modal-card" style="width: 25rem">
    <section class="modal-card-body">
      <b-field horizontal>
        {{ priceToMoney.toFormat() }}
      </b-field>
      <b-field horizontal label="sconto">
        <b-numberinput
          v-model="percentageDiscount"
          min="0"
          max="100"
          step="0.01"
          icon="percent"
        ></b-numberinput>
      </b-field>
      <b-field horizontal label="sconto">
        <b-numberinput
          v-model="priceDiscount"
          step="0.01"
          icon="euro-sign"
        ></b-numberinput>
      </b-field>
      <b-field horizontal label="=">
        <b>{{ total.toFormat() }}</b>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Annulla
      </button>
      <button class="button is-primary" @click="submit()">Conferma</button>
    </footer>
  </div>
</template>

<script>
export default {
  props: {
    price: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      percentageDiscount: 0,
      priceDiscount: 0
    }
  },
  computed: {
    priceToMoney() {
      return this.money(this.price)
    },
    validPercentageDiscount() {
      if (this.percentageDiscount) {
        if (this.percentageDiscount > 100) {
          return 100
        }
        return this.percentageDiscount
      }
      return 0
    },
    validPriceDiscount() {
      if (this.priceDiscount) {
        if (this.priceDiscount > this.price) {
          return this.price
        }
        return this.priceDiscount
      }
      return 0
    },
    total() {
      let result = this.priceToMoney
        .subtract(this.priceToMoney.percentage(this.validPercentageDiscount))
        .subtract(this.money(this.validPriceDiscount))

      if (result.isNegative()) {
        return this.money(0)
      }
      return result
    }
  },
  methods: {
    submit() {
      this.$emit("update", this.total.toUnit().toFixed(2))
      this.$parent.close()
    }
  }
}
</script>
